module.exports = __webpack_public_path__ + "img/ic-bank.9c54362b.svg";